import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

/* ── Brand Logo ──────────────────────────────────────────────── */
function BrandLogo() {
  return (
    <div className="brand-logo">
      <svg className="brand-icon" viewBox="0 0 32 32" fill="none">
        <rect width="32" height="32" rx="8" fill="var(--accent)"/>
        <ellipse cx="16" cy="16" rx="9" ry="5.5" stroke="white" strokeWidth="1.8"/>
        <circle cx="16" cy="16" r="3" fill="white"/>
      </svg>
      <span className="brand-name">AgentOversight</span>
    </div>
  );
}

/* ── Integrations ────────────────────────────────────────────── */
const INTEGRATIONS = [
  {
    name: 'OpenClaw',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M3 10s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z"/><circle cx="10" cy="10" r="2" fill="currentColor" stroke="none"/></svg>,
  },
  {
    name: 'LangChain',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><rect x="1" y="7" width="7" height="6" rx="3"/><rect x="12" y="7" width="7" height="6" rx="3"/><line x1="8" y1="10" x2="12" y2="10"/></svg>,
  },
  {
    name: 'LlamaIndex',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10 3L17 16H3L10 3z"/><line x1="7" y1="12" x2="13" y2="12"/></svg>,
  },
  {
    name: 'CrewAI',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="10" cy="6" r="3"/><path d="M4 17c0-3.3 2.7-6 6-6s6 2.7 6 6"/></svg>,
  },
  {
    name: 'AutoGen',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M17 10a7 7 0 1 1-1.6-4.4"/><polyline points="17 3 17 8 12 8"/></svg>,
  },
  {
    name: 'n8n',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="4" cy="10" r="2.5"/><circle cx="16" cy="4" r="2.5"/><circle cx="16" cy="16" r="2.5"/><line x1="6.2" y1="9" x2="13.8" y2="5"/><line x1="6.2" y1="11" x2="13.8" y2="15"/></svg>,
  },
  {
    name: 'LangGraph',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="10" cy="4" r="2"/><circle cx="3" cy="15" r="2"/><circle cx="17" cy="15" r="2"/><line x1="10" y1="6" x2="4.5" y2="13"/><line x1="10" y1="6" x2="15.5" y2="13"/><line x1="5" y1="15" x2="15" y2="15"/></svg>,
  },
  {
    name: 'OpenAI Agents',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M10 2a8 8 0 1 0 0 16A8 8 0 0 0 10 2z"/><path d="M10 6v4.5l3 1.5"/></svg>,
  },
  {
    name: 'Semantic Kernel',
    icon: <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><rect x="4" y="4" width="12" height="12" rx="2"/><rect x="7.5" y="7.5" width="5" height="5" rx="1"/><line x1="10" y1="2" x2="10" y2="4"/><line x1="10" y1="16" x2="10" y2="18"/><line x1="2" y1="10" x2="4" y2="10"/><line x1="16" y1="10" x2="18" y2="10"/></svg>,
  },
];

/* ── Dashboard Sidebar Icons (exact match to real app) ───────── */
const SB_ICONS = {
  grid:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  activity: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  cpu:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/></svg>,
  list:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  play:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  filetext: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  shield:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  barchart: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>,
  lock:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  settings: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
};

const SB_NAV = [
  { section: 'Monitor',  items: [{ label: 'Overview', icon: 'grid' }, { label: 'Traces', icon: 'activity' }, { label: 'Agents', icon: 'cpu' }, { label: 'Activity', icon: 'list' }] },
  { section: 'Evaluate', items: [{ label: 'Simulations', icon: 'play' }, { label: 'Prompts', icon: 'filetext' }] },
  { section: 'Control',  items: [{ label: 'Governance', icon: 'shield' }, { label: 'Quality', icon: 'barchart' }] },
  { section: 'Settings', items: [{ label: 'Key Vault', icon: 'lock' }, { label: 'Settings', icon: 'settings' }] },
];

/* ── Dashboard Sidebar ───────────────────────────────────────── */
function Sidebar({ active }) {
  return (
    <div className="sb-wrap">
      <div className="sb-logo">
        <span className="sb-logo-box">AO</span>
        <span className="sb-logo-text">Agent Oversight</span>
      </div>
      {SB_NAV.map(({ section, items }) => (
        <div key={section} className="sb-section">
          <p className="sb-section-label">{section}</p>
          {items.map(item => (
            <div key={item.label} className={`sb-item${item.label === active ? ' sb-active' : ''}`}>
              <span className="sb-icon">{SB_ICONS[item.icon]}</span>
              {item.label}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

/* ── macOS Chrome Frame ──────────────────────────────────────── */
function Chrome({ children, title }) {
  return (
    <div className="chrome-wrap">
      <div className="chrome-bar">
        <span className="chrome-dot cr"/><span className="chrome-dot cy"/><span className="chrome-dot cg"/>
        <span className="chrome-title">{title}</span>
      </div>
      {children}
    </div>
  );
}

/* ── Hero Mockup — Overview ──────────────────────────────────── */
function HeroMockup() {
  const activity = [
    { agent: 'support-agent',  event: 'Trace completed',     time: '2m ago',  s: 'active'   },
    { agent: 'pipeline-agent', event: 'Trace started',       time: '5m ago',  s: 'stale'    },
    { agent: 'onboard-agent',  event: 'Guardrail triggered', time: '12m ago', s: 'inactive' },
    { agent: 'support-agent',  event: 'Trace completed',     time: '18m ago', s: 'active'   },
  ];
  return (
    <Chrome title="AgentOversight — Overview">
      <div className="dm-body">
        <Sidebar active="Overview" />
        <div className="dm-content">
          <div className="dm-page-header">
            <div>
              <p className="dm-page-title">Overview</p>
              <p className="dm-page-sub">Platform health at a glance</p>
            </div>
            <span className="ov-live"><span className="dm-dot dm-dot-active"/>Live</span>
          </div>
          <div className="ov-stats">
            {[
              { label: 'Agents Online', value: '3',      sub: 'of 4 registered', c: '#22c55e' },
              { label: 'Traces Today',  value: '24',     sub: '2 in progress',   c: '#3b82f6' },
              { label: 'Guardrails',    value: 'Active', sub: '2 policies',      c: '#a855f7' },
            ].map(s => (
              <div key={s.label} className="ov-stat">
                <p className="ov-stat-label">{s.label}</p>
                <p className="ov-stat-value" style={{ color: s.c }}>{s.value}</p>
                <p className="ov-stat-sub">{s.sub}</p>
              </div>
            ))}
          </div>
          <div className="ov-activity-header">
            <span className="ov-activity-label">Recent Activity</span>
          </div>
          {activity.map((a, i) => (
            <div key={i} className="ov-row">
              <span className={`dm-dot dm-dot-${a.s}`}/>
              <span className="ov-agent">{a.agent}</span>
              <span className="ov-event">{a.event}</span>
              <span className="ov-time">{a.time}</span>
            </div>
          ))}
        </div>
      </div>
    </Chrome>
  );
}

/* ── Monitor Mockup — /dashboard/traces ──────────────────────── */
function MonitorMockup() {
  const traces = [
    { id: 'run_04a2b', agent: 'support-agent',  status: 'complete', spans: 12, tokens: '4,521', cost: '$0.0083', time: '2h ago'   },
    { id: 'run_09m3x', agent: 'pipeline-agent', status: 'complete', spans:  8, tokens: '2,130', cost: '$0.0041', time: '3h ago'   },
    { id: 'run_12k7p', agent: 'onboard-agent',  status: 'error',    spans:  5, tokens:   '890', cost: '$0.0021', time: '4h ago'   },
    { id: 'run_m3a9b', agent: 'support-agent',  status: 'complete', spans: 14, tokens: '6,240', cost: '$0.0112', time: '5h ago'   },
    { id: 'run_p1r7x', agent: 'pipeline-agent', status: 'running',  spans:  3, tokens:   '420', cost: '—',       time: 'just now' },
  ];
  return (
    <Chrome title="AgentOversight — Traces">
      <div className="dm-body">
        <Sidebar active="Traces" />
        <div className="dm-content">
          <div className="dm-page-header">
            <div>
              <p className="dm-page-title">Traces</p>
              <p className="dm-page-sub">Deep execution visibility for every agent run</p>
            </div>
            <span className="dm-count">1,247 traces (24h)</span>
          </div>
          <div className="dm-stats-row">
            {[
              { label: 'Total Traces', value: '1,247', c: '#3b82f6' },
              { label: 'Error Rate',   value: '2.3%',  c: '#ef4444' },
              { label: 'Avg Duration', value: '1.4s',  c: '#22c55e' },
              { label: 'Est. Cost',    value: '$2.14', c: '#f59e0b' },
            ].map(s => (
              <div key={s.label} className="dm-stat">
                <p className="dm-stat-label">{s.label}</p>
                <p className="dm-stat-value" style={{ color: s.c }}>{s.value}</p>
              </div>
            ))}
          </div>
          <div className="dm-table-wrap">
            <table className="dm-table">
              <thead>
                <tr><th>Name</th><th>Agent</th><th>Status</th><th>Spans</th><th>Tokens</th><th>Cost</th><th>Started</th></tr>
              </thead>
              <tbody>
                {traces.map(r => (
                  <tr key={r.id}>
                    <td className="dm-mono dm-primary">{r.id}</td>
                    <td>{r.agent}</td>
                    <td><span className={`dm-badge dm-badge-${r.status}`}>{r.status}</span></td>
                    <td>{r.spans}</td>
                    <td>{r.tokens}</td>
                    <td>{r.cost}</td>
                    <td className="dm-muted">{r.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Chrome>
  );
}

/* ── Evaluate Mockup — /dashboard/simulations ────────────────── */
function EvaluateMockup() {
  const sims = [
    { name: 'Support Agent v2',    desc: 'Customer support regression suite',  cases: 24, passed: 21, status: 'complete', date: 'Jan 15' },
    { name: 'Pipeline Regression', desc: 'Data processing accuracy tests',     cases: 12, passed: 10, status: 'complete', date: 'Jan 12' },
    { name: 'Onboard Flow v3',     desc: 'User onboarding edge case coverage', cases:  8, passed:  6, status: 'complete', date: 'Jan 10' },
  ];
  return (
    <Chrome title="AgentOversight — Simulation Lab">
      <div className="dm-body">
        <Sidebar active="Simulations" />
        <div className="dm-content">
          <div className="dm-page-header">
            <div>
              <p className="dm-page-title">Simulation Lab</p>
              <p className="dm-page-sub">Test agents against datasets and track regressions</p>
            </div>
            <span className="dm-btn-mock">New Simulation</span>
          </div>
          <div className="dm-table-wrap">
            <table className="dm-table">
              <thead>
                <tr><th>Name</th><th>Cases</th><th>Passed</th><th>Status</th><th>Created</th></tr>
              </thead>
              <tbody>
                {sims.map(s => (
                  <tr key={s.name}>
                    <td>
                      <p className="dm-row-title">{s.name}</p>
                      <p className="dm-muted">{s.desc}</p>
                    </td>
                    <td>{s.cases}</td>
                    <td><span style={{ color: '#22c55e' }}>{s.passed}</span><span className="dm-muted">/{s.cases}</span></td>
                    <td><span className="dm-badge dm-badge-complete">{s.status}</span></td>
                    <td className="dm-muted">{s.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Chrome>
  );
}

/* ── Control Mockup — /dashboard/governance ──────────────────── */
function ControlMockup() {
  const bundles = [
    { name: 'Security Bundle',     count: 5, color: '#ef4444', cat: 'Security', desc: 'PII, shell commands, file writes, web requests, credentials' },
    { name: 'Cost Control Bundle', count: 3, color: '#f59e0b', cat: 'Cost',     desc: '$5/day cap · 50k token limit · 100/hr rate limit'           },
    { name: 'Read-Only Bundle',    count: 3, color: '#3b82f6', cat: 'Security', desc: 'Blocks file writes, shell commands, external API calls'      },
    { name: 'Compliance Bundle',   count: 3, color: '#a855f7', cat: 'Privacy',  desc: 'PII detection · credential leaks · no DB operations'        },
  ];
  return (
    <Chrome title="AgentOversight — Governance">
      <div className="dm-body">
        <Sidebar active="Governance" />
        <div className="dm-content">
          <div className="dm-page-header">
            <div>
              <p className="dm-page-title">Governance</p>
              <p className="dm-page-sub">Policies, guardrails, and compliance</p>
            </div>
            <span className="dm-btn-mock">New Policy</span>
          </div>
          <div className="dm-tabs">
            <span className="dm-tab">Policies (6)</span>
            <span className="dm-tab dm-tab-active">Templates (13)</span>
            <span className="dm-tab">Violations (2)</span>
          </div>
          <div className="ctrl-bundles">
            {bundles.map(b => (
              <div key={b.name} className="ctrl-bundle">
                <div className="ctrl-bundle-header">
                  <div>
                    <p className="ctrl-bundle-name">{b.name}</p>
                    <p className="ctrl-bundle-desc">{b.desc}</p>
                  </div>
                  <span className="ctrl-install-btn">Install</span>
                </div>
                <div className="ctrl-bundle-footer">
                  <span className="ctrl-bundle-cat" style={{ color: b.color, background: b.color + '22' }}>{b.cat}</span>
                  <span className="ctrl-bundle-count">{b.count} policies</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Chrome>
  );
}

/* ── Vault Mockup — /dashboard/vault ─────────────────────────── */
function VaultMockup() {
  const keys = [
    { service: 'OpenAI',    label: 'production', preview: 'sk-...•••...Kx2A',  added: 'Dec 12', accessed: '2h ago'     },
    { service: 'Anthropic', label: 'staging',    preview: 'sk-ant-•••...Yp3B', added: 'Dec 14', accessed: '5h ago'     },
    { service: 'Pinecone',  label: 'production', preview: 'pc-...•••...Nm8C',  added: 'Dec 18', accessed: 'Yesterday'  },
  ];
  return (
    <Chrome title="AgentOversight — Key Vault">
      <div className="dm-body">
        <Sidebar active="Key Vault" />
        <div className="dm-content">
          <div className="dm-page-header">
            <div>
              <p className="dm-page-title">Key Vault</p>
              <p className="dm-page-sub">Encrypted storage for external API keys</p>
            </div>
            <span className="dm-btn-mock">Add Key</span>
          </div>
          <div className="dm-table-wrap">
            <table className="dm-table">
              <thead>
                <tr><th>Service</th><th>Label</th><th>Key Preview</th><th>Added</th><th>Last Accessed</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {keys.map(k => (
                  <tr key={k.service + k.label}>
                    <td className="dm-primary" style={{ fontWeight: 500 }}>{k.service}</td>
                    <td>{k.label}</td>
                    <td className="dm-mono dm-muted">{k.preview}</td>
                    <td className="dm-muted">{k.added}</td>
                    <td className="dm-muted">{k.accessed}</td>
                    <td>
                      <span className="dm-action">Audit</span>
                      <span className="dm-action-sep">·</span>
                      <span className="dm-action dm-action-danger">Revoke</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Chrome>
  );
}

/* ── Stats Strip ─────────────────────────────────────────────── */
function StatsStrip() {
  const stats = [
    { num: '13', label: 'built-in guardrails' },
    { num: '4',  label: 'one-click bundles'   },
    { num: 'AES-256', label: 'encrypted vault' },
    { num: 'Any', label: 'agent framework'    },
  ];
  return (
    <div className="stats-strip">
      {stats.map((s, i) => (
        <React.Fragment key={s.label}>
          {i > 0 && <span className="stats-sep" />}
          <div className="stat-item">
            <span className="stat-value">{s.num}</span>
            <span className="stat-label">{s.label}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

/* ── Landing Page ────────────────────────────────────────────── */
export default function Landing() {
  const features = [
    {
      id:      'monitor',
      eyebrow: 'Monitor',
      heading: 'See every execution in real time.',
      body:    'Every agent run is captured as a full trace — tool calls, token usage, latency, and cost. Filter, search, and drill into any execution without modifying your agent code.',
      cta:     'Explore monitoring',
      mockup:  <MonitorMockup />,
      gray:    true,
    },
    {
      id:      'evaluate',
      eyebrow: 'Evaluate',
      heading: 'Test before you trust.',
      body:    'Build simulation suites with real inputs and expected outputs. Run them against your agents, track pass rates, and catch regressions before your users do.',
      cta:     'Explore evaluation',
      mockup:  <EvaluateMockup />,
      gray:    false,
      rev:     true,
    },
    {
      id:      'control',
      eyebrow: 'Control',
      heading: 'Policies enforced on every run.',
      body:    'Ship agents without risk. Choose from 13 built-in guardrails — PII detection, credential protection, shell blocking, rate limits, and cost caps. Install a full Security Bundle in one click. Enforced at runtime. No code changes.',
      cta:     'Explore governance',
      mockup:  <ControlMockup />,
      gray:    true,
    },
    {
      id:      'vault',
      eyebrow: 'Key Vault',
      heading: 'Credentials your agents can trust.',
      body:    'Store API keys in an AES-256 encrypted vault. Agents request credentials at runtime — never hardcoded, never in prompts. Every access is logged with full audit trail.',
      cta:     'Explore the vault',
      mockup:  <VaultMockup />,
      gray:    false,
      rev:     true,
    },
  ];

  return (
    <div className="landing">

      {/* NAV */}
      <nav className="nav">
        <div className="nav-inner">
          <BrandLogo />
          <div className="nav-links">
            <Link to="/login" className="nav-link">Sign in</Link>
            <Link to="/signup" className="btn-primary btn-sm">Start Free Trial</Link>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-text-wrap">
          <h1 className="hero-h1">AI agents you can actually trust.</h1>
          <p className="hero-sub">
            Real-time traces, automated guardrails, and an encrypted key vault —
            purpose-built for teams shipping AI agents in production.
            No SDK. No rewrites. Live in minutes.
          </p>
          <div className="hero-ctas">
            <Link to="/signup" className="btn-primary btn-lg">Start Free Trial</Link>
            <a href="#monitor" className="hero-secondary">See How It Works</a>
          </div>
          <p className="hero-note">7-day free trial. Card required. Cancel anytime.</p>
        </div>
        <div className="hero-mockup">
          <HeroMockup />
        </div>
      </section>

      {/* STATS STRIP */}
      <StatsStrip />

      {/* EMPATHY */}
      <section className="empathy-section">
        <div className="empathy-inner">
          <div className="empathy-problems">
            {[
              'Runaway agent actions cost time, money, and trust.',
              'Hidden behavior leaves your team in the dark.',
              'Traditional observability was not built for agents.',
            ].map(p => (
              <div key={p} className="ep-item">
                <span className="ep-dash"/>
                <p className="ep-text">{p}</p>
              </div>
            ))}
          </div>
          <div className="empathy-solution">
            <p className="em-solution-text">
              AgentOversight gives you clarity and control before problems happen.
            </p>
          </div>
        </div>
      </section>

      {/* FEATURE SECTIONS — 4 real dashboard pages */}
      {features.map(f => (
        <section key={f.id} id={f.id} className={`feature-section${f.gray ? ' fs-gray' : ' fs-light'}`}>
          <div className={`fs-inner${f.rev ? ' fs-rev' : ''}`}>
            <div className="fs-text">
              <p className="fs-eyebrow">{f.eyebrow}</p>
              <h2 className="fs-h2">{f.heading}</h2>
              <p className="fs-body">{f.body}</p>
              <Link to="/signup" className="fs-cta">{f.cta} →</Link>
            </div>
            <div className="fs-visual">{f.mockup}</div>
          </div>
        </section>
      ))}

      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-inner">
          <div className="trust-grid">
            {[
              {
                title: 'Production-ready',
                body:  'Used by teams running hundreds of agents across LangChain, CrewAI, AutoGen, and custom frameworks.',
              },
              {
                title: 'Secure by design',
                body:  'AES-256 encrypted vault, JWT authentication, and full audit logging on every sensitive operation.',
              },
              {
                title: 'No lock-in',
                body:  'Works with any agent framework via a simple REST API. No SDK required. No infrastructure to manage.',
              },
            ].map(t => (
              <div key={t.title} className="trust-item">
                <p className="trust-title">{t.title}</p>
                <p className="trust-body">{t.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMPATIBLE WITH */}
      <section className="compat-section">
        <div className="compat-inner">
          <p className="compat-label">Works with your stack</p>
          <div className="compat-grid">
            {INTEGRATIONS.map(i => (
              <div key={i.name} className="compat-item">
                <span className="compat-icon">{i.icon}</span>
                <span className="compat-name">{i.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="cta-section">
        <div className="cta-inner">
          <h2 className="cta-h2">Start trusting your AI agents.</h2>
          <Link to="/signup" className="btn-primary btn-lg cta-btn">Start Free Trial</Link>
          <p className="cta-note">7-day free trial. Cancel anytime.</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <BrandLogo />
          <div className="footer-links">
            <Link to="/login">Sign in</Link>
            <Link to="/signup">Sign up</Link>
          </div>
        </div>
      </footer>

    </div>
  );
}
